import CustomToast from "components/atoms/CustomToast";
import Button from "components/common/buttons/buttons";
import { useSession } from "next-auth/react";
import { useState } from "react";
import {
  debateAlarmSubmit,
  useDebateAlarmOnoff,
} from "utils/clientAPIs/debate";

function AlarmButton({ isMobile }: { isMobile: boolean }) {
  const [isDebateAlarmOff, isValid, mutate] = useDebateAlarmOnoff();
  const [alarmRegisterToast, setAlarmRegisterToast] = useState(false);
  const { data: session }: any = useSession();
  if (isDebateAlarmOff) {
    return (
      <div
        className={
          isMobile
            ? `z-[99] bg-white w-full px-5 pt-4 pb-[30px] fixed bottom-0 left-0 !font-semibold flex flex-col gap-4 `
            : `z-[99] bg-white w-[800px] px-5 pt-4 pb-[30px] fixed bottom-0 left-[50%] translate-x-[-50%] !font-semibold flex flex-col gap-4  `
        }
      >
        <Button
          type="primary"
          size="lg"
          text="토론 업데이트 알림 받기"
          width="w-full"
          clickHandler={async () => {
            await debateAlarmSubmit(
              session,
              {
                isDebateAlarmOn: !isDebateAlarmOff,
              },
              mutate
            );
            setAlarmRegisterToast(true);
          }}
        />
      </div>
    );
  } else
    return (
      <CustomToast
        message="이제부터 토론 알림을 받아요"
        isVisible={alarmRegisterToast}
        onClose={() => setAlarmRegisterToast(false)}
        isSuccess={true}
        width={250}
        successIconFill={"#34BB7A"}
      />
    );
}

export default AlarmButton;
